Hearsay = require 'hearsay'
Promise = require 'bluebird'
assert = require 'lib/assert'

errorSignal = new Hearsay.Emitter()
errorSignal.use()

class ErrorInfo
  constructor: (@error, @url = document.location.href, @line = 0, @col = 0) ->
    assert @error?

window.onerror = (msg, url, line, col, error) ->
  error ?= new Error(msg)
  errorSignal.send new ErrorInfo(error, url, line, col)

Promise.onPossiblyUnhandledRejection (error) ->
  errorSignal.send new ErrorInfo(error)

module.exports = errorSignal



// WEBPACK FOOTER //
// ./app/scripts/lib/error-signal.coffee